import focus from "./focus.js";

function install(Vue) {
  Vue.directive("focus", focus);
}

focus.install = install;

export default focus;
